import {Injectable} from "@angular/core";
import {EventDetailsDto} from "../../../../../../models/event/event-details";
import {TimeRepository} from "../time-repository/time-repository";
import {SalesWrapper} from "../../../utils/sales/sales-wrapper";
import {SalesUtils} from "../../../utils/sales/sales-utils";
import {LinkedDtoRepository} from "../../../../common/repositories/linked-dto-repository";
import {FilterHelper} from "../../../utils/filter/filter-helper";
import {SalesDto} from "../../../models/sales/sales-dto";
import {FilterVO} from "../../../../common/utils/filter/models/filter-vo";

/*{
  providedIn: 'root'
}*/
@Injectable(
)
export class SalesRepository {
  salesWrapper: SalesWrapper = new SalesWrapper();
  salesWrapperCache: SalesWrapper = new SalesWrapper();
  filterHelper: FilterHelper = new FilterHelper();
  swapOrderElementsSet: {
    employeeSalesZeroRevenueSet: { [id: string]: SalesDto },
    employeeSalesZeroRevenueSetOriginal: { [id: string]: SalesDto }
  } = {employeeSalesZeroRevenueSet: {}, employeeSalesZeroRevenueSetOriginal: {}};

  constructor(private timeRepository: TimeRepository,
              private linkedDtoRepository: LinkedDtoRepository<any>) {
  }

  getSalesWrapper(): SalesWrapper {
    return this.salesWrapper;
  }

  getCachedSalesWrapper() {
    return this.salesWrapperCache
  }

  public initialize(eventDto: EventDetailsDto) {
    this.salesWrapper = SalesUtils.createBaseOrderElementsWrapperFromEventEdto(eventDto, this.timeRepository.getTimeIntervalBO());
    // clears the cached list
    this.salesWrapperCache.clear();
  }

  public postInitialize() {
    SalesUtils.calculateTotalRevenueAfterTax(this.salesWrapper, this.linkedDtoRepository);
    SalesUtils.setSourceDeailsCost(this.salesWrapper, this.linkedDtoRepository);

    this.swapOrderElementsSet = SalesUtils.createDuplicatedZeroRevenueSet(this.salesWrapper);
  }

  addFilter<T>(filter: FilterVO<T>, stackable: boolean = false): void {
    if (!stackable) {
      if (this.filterHelper.filterExists(filter)) {
        return;
      }
    }

    this.filterHelper.addFilter(filter);
  }

  removeFilter<T>(filter: FilterVO<T>): void {
    this.filterHelper.removeFilter(filter);
  }


  update(revenueFn: (salesDto: SalesDto) => number) {
    this.filterHelper.applyFilter(this.salesWrapper, this.salesWrapperCache);
    this.salesWrapper.generateOriginalValueQuantitativeBaseOrderCacheVO(["locationId"])
    this.salesWrapper.generateQuantitativeBaseOrderCacheVO(["locationId", "compositionTypeId", "bookingType"], revenueFn);


    this.salesWrapper.generateTotalRevenue(SalesUtils.getRevenue)
    this.salesWrapper.generateTotalTaxes(SalesUtils.getRevenue, this.linkedDtoRepository)
    this.salesWrapper.generateTotalSourceDetailsCost(SalesUtils.getSourceDetailCost)
    this.salesWrapper.generateNumberOfSoldArticles()


  }

  public getTotalRevenue(): number {
    return this.salesWrapper.totalRevenue;
  }

  public getTotalTaxes(): number {
    return this.salesWrapper.totalTaxes;
  }

  getTotalSourceDetailsCost(): number {
    return this.salesWrapper.totalSourceDetailsCost;
  }

  getSoldArticleCount(): number {
    return this.salesWrapper.numberOfSoldArticles;
  }

  getRevenueByAttribute(attribute: keyof SalesDto): { id: string, value: number }[] {
    return this.salesWrapper.quantitativeBaseOrderCacheVO.dataCache[attribute];
  }

  swapZeroRevenueSet(direction: boolean) {
    SalesUtils.swapZeroRevenueSet(this.salesWrapper, this.salesWrapperCache, this.swapOrderElementsSet, direction)
  }

}
